import React from 'react';
import  { ListItem, ListItemIcon, ListItemText, ListSubheader, Tooltip } from '@material-ui/core'
import {NavLink} from "react-router-dom";
import { mainMenuItem, secondListItem } from '../../config/backendRoutes';
import Can from '../../services/RolePermissionService';

export const MainListItems = props => (
  <div>
     {mainMenuItem.map(section => (
       <Can do="view" on={section.url} key={section.name}>
          <Tooltip title={props.open ? '' : section.name} placement="right" key={section.name}>
              <ListItem button key={section.name} component={NavLink} exact to={section.url} 
                selected={props.location === section.url}
              >
                  <ListItemIcon>
                    {section.icon}
                  </ListItemIcon>
                  <ListItemText primary={section.name}/>
              </ListItem>
          </Tooltip>
        </Can>
      ))}
  </div>
);

export const SecondaryListItems = props => (
  <div>
    {props.open ? <ListSubheader inset color="primary">Reports</ListSubheader> : null}
     {secondListItem && secondListItem.map(section =>(
      <Can do="view" on={section.url} key={section.name}>
        <Tooltip title={props.open ? '' : section.name} placement="right" key={section.name}>
            <ListItem button key={section.name} component={NavLink} exact to={section.url} 
              selected={props.location === section.url}
            >
              <ListItemIcon>
                {section.icon}
              </ListItemIcon>
              <ListItemText primary={section.name} />
            </ListItem>
        </Tooltip>
      </Can>
     ))}
  </div>
);
